import { render, staticRenderFns } from "./MobileWsp.vue?vue&type=template&id=0f7235a8&scoped=true&"
import script from "./MobileWsp.vue?vue&type=script&lang=js&"
export * from "./MobileWsp.vue?vue&type=script&lang=js&"
import style0 from "./MobileWsp.vue?vue&type=style&index=0&id=0f7235a8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7235a8",
  null
  
)

export default component.exports